/* values below must match db Roles table RoleDesc - REVISIT if an explicit lookup API call is preferable to this front-end enum mirror */
export enum UserSubRoleType {
    ['Revenue Management'] = 1,
    ['F&A'] = 2,
    TSA = 3
}

// corresponds to back-end UserRolesEnum
export enum UserRolesEnum {
    Admin = 'Admin',
    AEUser = 'AE User',
    Pricing = 'Pricing',
    SalesSupport='Sales Support',
    FinanceUser='Finance User',
    RPFBillers='RPF Billers',
    FinanceManager='Finance Manager',
    FinanceDirector='Finance Director',
    GBSBilling='GBS Billing',
    OperationsManager='Operations Manager',
    OperationsRegionalManager='Operations Regional Manager',
    GBSCollection='GBS Collection',
    DistrictManager ='GBS District Manager'
}



export enum UserRoleType {
AE_User = 1,
Pricing = 2,
Sales_Support = 3,
Finance_User = 4,
Admin = 5,
RPF_Billers=6,
Finance_Manager=7,
Finance_Director=8,
GBS_Billing=9,
Operations_Manager=10,
Operations_Regional_Manager=11,
GBS_Collection=12,
Supervisor=13,
Manager=14,
District_Manager = 15
}